module.exports = __webpack_public_path__ + "assets/img/id-card-front.084e075b.png";